import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { getClient } from '@sentry/react';

/**
 * Интеграция Sentry с axios для отслеживания ошибок в HTTP запросах
 */
export const axiosSentryIntegration = () => {
  const originalRequestUse = axios.interceptors.request.use;
  const originalResponseUse = axios.interceptors.response.use;

  // Переопределяем перехватчик запросов
  axios.interceptors.request.use = function (
    onSuccess?: ((value: InternalAxiosRequestConfig) => InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig>) | null,
    onError?: ((error: any) => any) | null
  ) {
    return originalRequestUse.call(
      this,
      onSuccess ? (...args) => {
        try {
          return onSuccess(...args) as InternalAxiosRequestConfig<any> | Promise<InternalAxiosRequestConfig<any>>;
        } catch (error) {
          console.error('Error in request onSuccess interceptor', error);
          getClient()?.captureException(error, {});
          return error as InternalAxiosRequestConfig<any> | Promise<InternalAxiosRequestConfig<any>>;
        }
      } : onSuccess, // Pass null through if it's null
      onError ? (error) => {
        try {
          getClient()?.captureException(error, {});
          return onError(error) ?? error;
        } catch (onErrorError: unknown) {
          console.error('Error in request onError interceptor', onErrorError);
          getClient()?.captureException(onErrorError, {});
          return onErrorError;
        }
      } : onError // Pass null through if it's null
    );
  };

  // Переопределяем перехватчик ответов
  axios.interceptors.response.use = function (
    onSuccess?: ((value: AxiosResponse) => AxiosResponse | Promise<AxiosResponse>) | null,
    onError?: ((error: AxiosError) => any) | null
  ) {
    return originalResponseUse.call(
      this,
      onSuccess ? async (value) => {
        try {
          return (await onSuccess(value)) ?? value;
        } catch (error) {
          console.error('Error in response onSuccess interceptor', error);
          getClient()?.captureException(error, {});
          return value;
        }
      } : onSuccess, // Pass null through if it's null
      onError ? (error) => {
        try {
          getClient()?.captureException(error, {});
          return onError(error) ?? error;
        } catch (exErr) {
          console.error('Error in response onError interceptor', exErr);
          getClient()?.captureException(exErr, {});
          return error;
        }
      } : onError // Pass null through if it's null
    );
  };
};